import { PlayCircle, UserPlus, Crown, Wallet, Gift } from "lucide-react";
import { useI18n } from "../i18n";
import { useSettings } from "../lib/providers";
import { publicFileUrl } from "../lib/plans";

const ICONS = { register: UserPlus, packages: Crown, payment: Wallet, benefits: Gift };

const toEmbed = (url) => {
  const m = (url || "").match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
};

const VideoCard = ({ item }) => {
  const { t } = useI18n();
  const embed = toEmbed(item.url);
  const Icon = ICONS[item.key] || PlayCircle;
  const title = item.title || (item.key ? t(`tut_${item.key}`) : "");
  const desc = item.description || (item.key ? t(`tut_${item.key}_d`) : "");
  return (
    <div className="lux-card overflow-hidden" data-testid={`tutorial-card-${item.id}`}>
      <div className="relative aspect-video bg-[color:var(--surface-2)]">
        {item.video_path ? (
          <video src={publicFileUrl(item.video_path)} controls preload="metadata" className="h-full w-full bg-black" data-testid={`tutorial-file-${item.id}`} />
        ) : embed ? (
          <iframe src={embed} title={title} className="h-full w-full" allow="accelerometer; encrypted-media; picture-in-picture" allowFullScreen data-testid={`tutorial-video-${item.id}`} />
        ) : (
          <div className="grain relative flex h-full flex-col items-center justify-center gap-2" data-testid={`tutorial-placeholder-${item.id}`}>
            <PlayCircle className="h-14 w-14 transition-transform duration-300 hover:scale-110" style={{ color: "var(--gold)" }} />
            <span className="text-xs uppercase tracking-widest text-muted-foreground">{t("tut_coming")}</span>
          </div>
        )}
      </div>
      <div className="flex gap-3 p-5">
        <Icon className="mt-1 h-5 w-5 shrink-0" style={{ color: "var(--gold)" }} />
        <div><h3 className="font-serif text-xl font-semibold">{title}</h3><p className="mt-1 text-sm text-muted-foreground">{desc}</p></div>
      </div>
    </div>
  );
};

export const TutorialGrid = () => {
  const { settings } = useSettings();
  return (
    <div className="grid gap-6 md:grid-cols-2">
      {(settings?.tutorials || []).map((it) => <VideoCard key={it.id} item={it} />)}
    </div>
  );
};

export const TutorialSection = () => {
  const { t } = useI18n();
  return (
    <section id="tutorials" className="mx-auto max-w-7xl px-5 py-24 lg:px-8" data-testid="tutorial-section">
      <p className="eyebrow">{t("tut_eyebrow")}</p>
      <h2 className="mt-3 font-serif text-4xl font-semibold sm:text-5xl">{t("tut_title")}</h2>
      <p className="mt-4 max-w-2xl text-muted-foreground">{t("tut_sub")}</p>
      <div className="mt-14"><TutorialGrid /></div>
    </section>
  );
};
